import { API_BASE, apiFetch, authHeaders, parseApiError } from './apiClient';

export async function fetchTolls() {
  const response = await apiFetch(`${API_BASE}/tolls`, {
    headers: authHeaders(),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudieron cargar los peajes'));
  }
  return Array.isArray(payload) ? payload : [];
}

export async function createToll(body) {
  const response = await apiFetch(`${API_BASE}/tolls`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo crear el peaje'));
  }
  return payload;
}

export async function updateToll(id, body) {
  const response = await apiFetch(`${API_BASE}/tolls/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo actualizar el peaje'));
  }
  return payload;
}

export async function deleteToll(id) {
  const response = await apiFetch(`${API_BASE}/tolls/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo eliminar el peaje'));
  }
  return payload;
}
